export default "__VITE_ASSET__dNFBf27v__"